export const GET_WORKSPACE_RIGHTS = 'GET_WORKSPACE_RIGHTS';




